import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_SIZE, DELETE_SIZE, GET_SIZE, UPDATE_SIZE, GET_ONE_SIZE, MULTI_DELETE_SIZE } from '../types';

export const getSize = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/size/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_SIZE,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error("Failed to get Size. Please try again. :", err);
   }
};

export const addSize = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/size/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_SIZE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Size added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data)
         if (err.response && err.response.data && err.response.data.code === 1) {
            return;
         }
      const errorMessage = err?.response?.data?.message;
      toast.error(errorMessage || 'An error occurred. Please try again.');
      // if (err.response.data.errors[0].message) {
      //   toast.error(err.response.data.errors[0].message);
      // }
   }
};

export const updateSize = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/size/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_SIZE, payload: res.data.data });

         setTimeout(() => {
            toast.success('Size updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // toast.error("Failed to update Size. Please try again.");
   }
};

// Delete Size
export const deleteSize = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/size/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_SIZE, payload: { id } });
         setTimeout(() => {
            toast.success('Size deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // toast.error("Failed to delete Size. Please try again.");
   }
};

export const multiDeleteSize = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/size/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_SIZE, payload: res.data.data });

         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const getSingleSize = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/size/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_SIZE, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
